import React, { FC, useEffect } from 'react';
import { Box, Checkbox, FormControl } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { InstructionsType } from '../../types';
import suggestionIcon from 'assets/images/icons/suggestionIcon.svg';
import { Dropdown } from '@mui/base/Dropdown';
import { MenuItem as BaseMenuItem } from '@mui/base/MenuItem';
import { MenuButton as BaseMenuButton } from '@mui/base/MenuButton';
import { Menu } from '@mui/base/Menu';
import styled from '@emotion/styled';
import { getInstructionHistoryQuery, getInstructionSuggestionsQuery } from 'api/queries/settings';
import i18n from 'i18n';
import { makeShort } from 'helpers/strings';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import HistoryIcon from '@mui/icons-material/History';
import { SuggestionType } from 'store/global/types';

const Instructions: FC<InstructionsType> = ({
    onChange,
    value,
    handleCheckboxForFeatureVersions,
    isCheckedForFeatureVersions,
}) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const { instructionHistory, instructionSuggestions } = useAppSelector((state) => state.global);
    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        onChange('instructions', event.target.value);
    };

    const onChooseSuggesstion = (item: string) => {
        onChange('instructions', value ? `${value}\n\n${item}` : `${item}`);
    };

    useEffect(() => {
        getInstructionSuggestionsQuery(dispatch);
        getInstructionHistoryQuery(dispatch);
    }, [dispatch]);

    const getTranslatedSuggestions = (suggestions: SuggestionType[]) => {
        return suggestions?.map((item) => ({
            ...item,
            prompt: i18n.exists(
                `web_app.additiona_settings.instructions.suggestions.prompts[${item.id}]`,
            )
                ? t(`web_app.additiona_settings.instructions.suggestions.prompts[${item.id}]`)
                : item.prompt,
            title: i18n.exists(`web_app.additiona_settings.instructions.suggestions[${item.id}]`)
                ? t(`web_app.additiona_settings.instructions.suggestions[${item.id}]`)
                : item.title,
        }));
    };

    return (
        <FormControl fullWidth className="instruction-container">
            <Box className="filter-container-body-description" style={{ padding: '6px 0' }}>
                {t('web_app.additiona_settings.instructions_description')}
            </Box>
            <Box className="instruction-container-textarea">
                <textarea
                    name="feedback"
                    placeholder={t('web_app.additiona_settings.instructions_placeholder')}
                    value={value}
                    onChange={handleChange}
                    rows={3}
                />
                <Box className="instruction-suggestion">
                    <Dropdown>
                        <MenuButton className="instruction-suggestion-btn">
                            <img src={suggestionIcon} alt="sugestionIcon" />
                            {t('web_app.additiona_settings.instructions.suggestions_btn')}
                        </MenuButton>
                        <Menu
                            slots={{ listbox: Listbox }}
                            style={{ zIndex: 12010 }}
                            className="dropdown suggestion-dropdown"
                        >
                            {getTranslatedSuggestions(instructionSuggestions).map((item) => (
                                <MenuItem key={item.id}>
                                    <span>{item.title}</span>
                                    <button onClick={() => onChooseSuggesstion(item.prompt)}>
                                        {t('web_app.additiona_settings.instructions.insert')}
                                    </button>{' '}
                                </MenuItem>
                            ))}
                        </Menu>
                    </Dropdown>
                </Box>
                {instructionHistory?.length !== 0 && (
                    <Box className="instruction-suggestion instruction-history">
                        <Dropdown>
                            <MenuButton className="instruction-suggestion-btn">
                                {/* <img src={suggestionIcon} alt="sugestionIcon" /> */}
                                <HistoryIcon />
                                {t('web_app.additiona_settings.instructions.history_btn')}
                            </MenuButton>
                            <Menu
                                slots={{ listbox: Listbox }}
                                style={{ zIndex: 12010 }}
                                className="dropdown suggestion-dropdown"
                            >
                                {instructionHistory.map((item) => (
                                    <MenuItem key={item.document_id}>
                                        <span>{makeShort(item.value, 200)}</span>
                                        <button onClick={() => onChooseSuggesstion(item.value)}>
                                            {t('web_app.additiona_settings.instructions.insert')}
                                        </button>{' '}
                                    </MenuItem>
                                ))}
                            </Menu>
                        </Dropdown>
                    </Box>
                )}
                <Box className="instruction-container-textarea-footer">
                    <Box>
                        <Checkbox
                            onChange={handleCheckboxForFeatureVersions}
                            checked={isCheckedForFeatureVersions}
                        />
                        <span>{t('web_app.additiona_settings.instructions.save_checkbox')}</span>
                    </Box>
                </Box>
            </Box>
        </FormControl>
    );
};

export default Instructions;

const Listbox = styled('ul')(() => ``);
const MenuItem = styled(BaseMenuItem)(() => ``);
const MenuButton = styled(BaseMenuButton)(() => ``);
